import type { ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

export function PageShell({ title, children, actions }: Props) {
  return (
    <div className="flex min-h-[var(--vh)] flex-col bg-[var(--color-bg)] text-[var(--color-fg)]">
      <header
        className="flex items-center justify-between px-4 py-3"
        style={{ paddingTop: 'calc(var(--safe-top, 0px) + 12px)' }}
      >
        <h1 className="text-lg font-semibold">{title}</h1>
        {actions}
      </header>
      <main className="flex-1 overflow-y-auto pb-[calc(var(--safe-bottom,0px)+72px)]">
        {children}
      </main>
    </div>
  );
}
